
import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { NgxSpinnerService } from 'ngx-spinner';
import { ArtTypeService } from 'src/app/Services/art-type.service';
import { ArtistsService, Artist } from 'src/app/Services/artists.service';
import { AuthService, AuthConfig, ResponseObject } from 'src/app/Services/auth.service';
import { GalleriesService, GalleryAddress, GalleryItems } from 'src/app/Services/galleries.service';
import { Cities, Countries, RegistrationsService, States } from 'src/app/Services/registration.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { NotificationTypes } from 'src/app/app.enums';
import { SetupItems } from 'src/app/models/setupItems';
import { environment } from 'src/environments/environment';
import { TranslocoService } from '@jsverse/transloco';
@Component({
    selector: 'app-registration',
    templateUrl: './registration.component.html',
    providers: [AuthService, ArtistsService, GalleriesService,],
    standalone: false
})
export class RegistrationComponent implements OnInit {
  public showAdditionalInfo: boolean = false;
  public hidelable: boolean = true;
  public artTypes: SetupItems[] = [];
  public authConfig: AuthConfig = {};
  public invitationId!: string;
  public signupForm: Artist = {} as Artist;
  public currencyCode: string | undefined;

  constructor(@Inject(LOCALE_ID) private locale: string, 
    private router: Router,
    private jwtHelper: JwtHelperService,
    private ngxSpinnerService: NgxSpinnerService,
    private artistService: ArtistsService,
    private registrationsService: RegistrationsService,
    private authService: AuthService,
    private galleriesService: GalleriesService,
    private artTypeService: ArtTypeService,
    private notificationsService: NotificationsService,
    private transloco: TranslocoService) { }

  public ngOnInit(): void {
    if (this.authService.isAuthenticated()) {
      //check if the angular application is running in an iframe or not
      if (window.self === window.top) {
        //not an iframe so proceed with the normal flow
        this.router.navigate(['/']);
      } else {
        console.log('User is viewing this page in the iframe so lets see if he is in production=> ' + environment.production);
        //user is viewing the site in the iframe so navigate him properly to the portal site
         if (environment.production && window.parent) {
        window.parent.location.href = environment.portalUrl;
      }
      }
    }

    console.log('Production: ' + environment.production);
    this.getArtTypes();
    this.fetchCountries()

  //   this.currencyCode = new Intl.NumberFormat(this.locale, {
  //     style: 'currency',
  //     currency: 'USD' // Default currency code
  // }).resolvedOptions().currency;

  }

  private onAfterRegistration() {
    //check if the angular application is running in an iframe or not
    if (window.self === window.top) {
      
      //not an iframe so proceed with the normal reload
      window.location.reload();
    } else {
      //user is viewing the site in the iframe so navigate him properly to the portal site
      if (environment.production && window.parent) {
        //we're on the production site, so redirect the user to the main portal (moving him out from the iframe on the public site)
        window.parent.location.href = 'https://portal.artflow-pro.com';
      }
    }
  }

  private onAfterRegistration2(){

  }

  private login(userName: string, password: string) {
    this.ngxSpinnerService.show();
    this.authService.login({ Username: userName, Password: password }).subscribe((loginResponse: ResponseObject) => {
      if (loginResponse.Success) {
        this.onAfterRegistration();
      }
      this.ngxSpinnerService.hide();
    }, error => { console.error(error); this.ngxSpinnerService.hide(); });
  }

  private saveArtist() {
    this.ngxSpinnerService.show();
    this.signupForm.CurrencyCode = this.currencyCode;
    this.artistService.saveArtist(this.signupForm).subscribe((response) => {
      this.ngxSpinnerService.hide();
      if (response.Success) {
        this.onAfterRegistration2();
        //this.login(this.signupForm.Email, this.signupForm.Password);
      } else { this.notificationsService.showNotification(this.transloco.translate('registration.error'), response.ResponseMessage, NotificationTypes.Error); }
    }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
  }

  private saveGallery() {
    const galleryAddress: GalleryAddress = {
      State: this.signupForm.State,
      Address1: this.signupForm.AddressLine1,
      Address2: this.signupForm.AddressLine2,
    };
    // Create a new object with only the required properties
    const galleryData: GalleryItems = {
      // Name: this.signupForm.Name,
      FirstName: this.signupForm.FirstName,
      LastName: this.signupForm.LastName,
      UserName: this.signupForm.UserName,
      Email: this.signupForm.Email,
      PhoneNumber: this.signupForm.PhoneNumber,
      Password: this.signupForm.Password,
      Country: this.signupForm.Country,
      City: this.signupForm.City,
      Zip: this.signupForm.Zip,
      BusinessName: this.signupForm.BusinessName,
      GalleryAddresses: [galleryAddress],
      CurrencyCode: this.signupForm.CurrencyCode
    };

    this.ngxSpinnerService.show();
    this.galleriesService.saveGallery(galleryData).subscribe((response: ResponseObject) => {
      this.ngxSpinnerService.hide();
      if (response.Success) {
        this.onAfterRegistration2();
        //this.login(galleryData.Email, galleryData.Password!);
      } else { this.notificationsService.showNotification(this.transloco.translate('registration.error'), response.ResponseMessage, NotificationTypes.Error); }
    }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
  }

  public isPasswordMismatch(): boolean {
    return this.signupForm.Password !== this.signupForm.ConfirmPassword;
  }

  private getArtTypes() {
    this.artTypeService.fetch().subscribe((artTypes: SetupItems[]) => {
      this.artTypes = artTypes;
    }, (error) => { console.error('Error fetching art types:', error); });
  }

// Correct Properties
public selectedCountryId!: number;
public selectedStateId!: number;
public selectedCityId!: number;

// Add helper fields to store selected names
public selectedCountryName!: string;
public selectedStateName!: string;
public selectedCityName!: string;

   
   public countries: Countries[] = [];
   public states: States[] = [];
   public cities: Cities[] = [];
 

private fetchCountries(): void {
  this.registrationsService.getAllCountries().subscribe(
    (countries: Countries[]) => {
      this.countries = countries;
      console.log('Fetched countries:', this.countries);
    },
    (error) => {
      console.error('Error fetching countries:', error);
    }
  );
}


// Fetch states based on selected country
private fetchStates(countryId: number): void {
  this.registrationsService.getAllStates(countryId).subscribe(
    (states: States[]) => {
      this.states = states;
      console.log('Fetched states:', this.states);
    },
    (error) => {
      console.error('Error fetching states:', error);
    }
  );
}

// Fetch cities based on selected state
private fetchCities(stateId: number): void {
  this.registrationsService.getAllCities(stateId).subscribe(
    (cities: Cities[]) => {
      this.cities = cities;
      console.log('Fetched cities:', this.cities);
    },
    (error) => {
      console.error('Error fetching cities:', error);
    }
  );
}
// When user selects a country
public onCountryChange(event: any): void {
  const selectedId = +event.target.value;
  this.selectedCountryId = selectedId;

  // Find selected Country object
  const selectedCountryObj = this.countries.find(c => c.id === selectedId);
  this.selectedCountryName = selectedCountryObj ? selectedCountryObj.name : '';

  // Console for debugging
  console.log('Selected Country ID:', this.selectedCountryId);
  console.log('Selected Country Name:', this.selectedCountryName);

  // Reset State & City selections
  this.selectedStateId = undefined!;
  this.selectedCityId = undefined!;
  this.states = [];
  this.cities = [];

  // Fetch states if country is selected
  if (this.selectedCountryId) {
    this.fetchStates(this.selectedCountryId);
  }
}

// When user selects a state
public onStateChange(event: any): void {
  const selectedId = +event.target.value;
  this.selectedStateId = selectedId;

  // Find selected State object
  const selectedStateObj = this.states.find(s => s.id === selectedId);
  this.selectedStateName = selectedStateObj ? selectedStateObj.name : '';

  // Console for debugging
  console.log('Selected State ID:', this.selectedStateId);
  console.log('Selected State Name:', this.selectedStateName);

  // Reset City selection
  this.selectedCityId = undefined!;
  this.cities = [];

  // Fetch cities if state is selected
  if (this.selectedStateId) {
    this.fetchCities(this.selectedStateId);
  }
}

// When user selects a city
public onCityChange(event: any): void {
  const selectedId = +event.target.value;
  this.selectedCityId = selectedId;

  // Find selected City object
  const selectedCityObj = this.cities.find(c => c.id === selectedId);
  this.selectedCityName = selectedCityObj ? selectedCityObj.name : '';

  // Console for debugging
  console.log('Selected City ID:', this.selectedCityId);
  console.log('Selected City Name:', this.selectedCityName);
}

  public register() {
    this.signupForm.Country = this.selectedCountryName!;
    this.signupForm.State = this.selectedStateName;   
    this.signupForm.City = this.selectedCityName;  
    console.log('Form Data:', this.signupForm);
    if (this.signupForm.AccountType === 'Artist') {
      this.saveArtist();
    } else if (this.signupForm.AccountType === 'Gallery') {
      this.saveGallery();
    }
  }
}

